// extracted by mini-css-extract-plugin
export default {"root":"RevokeUserConfirmationModal_root__61fpm","sub-header":"RevokeUserConfirmationModal_sub-header__ejsms"};